import useRecordTimeOfMostRecentUserActivity from '../../common-components/hooks/useRecordTimeOfMostRecentUserActivity'


export default ({
  children,
}) => {
  useRecordTimeOfMostRecentUserActivity()
  return children
}
